import { ChangeEvent, Fragment } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Address, BillingInformation, ContactNumber, Country, Email, FirstName, LastName, OtherNotes, ProceedToNext, RememberMeNext, State, ZipCode } from "../../../../../../constants";
import { ActiveCallbackProp, BillingFormData } from "../../../../../../types/Forms";
import { CountryData } from "../../../../../../data/formsAndTable/forms/FormLayout";
import { useForm } from "react-hook-form";

const BillingForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm<BillingFormData>({});

  const formData = watch();

  const handleNextButton = handleSubmit(
    () => {
      if (formData.firstName !== "" && formData.lastName !== "" && formData.contact !== "" && formData.email !== "" && formData.address !== "" && formData.country !== "" && formData.state !== "" && formData.zip !== "" && formData.agreeTerms !== false && formData.otherNotes !== "") activeCallBack(2);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    let value: string | boolean = "";
    if (name === "agreeTerms") {
      value = event.target.checked;
    } else {
      value = event.target.value ?? "";
    }
    setValue(name as keyof BillingFormData, value, { shouldValidate: true, shouldDirty: true });
    //shouldValidate will check whether the input is valid or not
    //shouldDirty will check whether the input is dirty or not
  };

  return (
    <Fragment>
      <h6>{BillingInformation}</h6>
      <p className="f-light">{"Fill up the following information "}</p>
      <Form onSubmit={(event) => event.preventDefault} className="needs-validation " noValidate>
        <Row className="g-3">
          <Col sm="6">
            <Label>
              {FirstName}
              <span className="txt-danger">*</span>
            </Label>
            <Input {...register("firstName", { required: "First name is required" })} value={formData.firstName} onChange={updateFormData} type="text" placeholder="Enter first name" />
            {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
          </Col>
          <Col sm="6">
            <Label>
              {LastName}
              <span className="txt-danger">*</span>
            </Label>
            <Input {...register("lastName", { required: "Last name is required" })} value={formData.lastName} onChange={updateFormData} type="text" placeholder="Enter last name" />
            {errors.lastName && <span className="text-danger">{errors.lastName.message}</span>}
          </Col>
          <Col sm="6">
            <Label>{ContactNumber}</Label>
            <Input {...register("contact", { required: "Contact number is required" })} value={formData.contact} onChange={updateFormData} type="number" placeholder="Enter number" />
            {errors.contact && <span className="text-danger">{errors.contact.message}</span>}
          </Col>
          <Col sm="6">
            <Label>
              {Email}
              <span className="txt-danger">*</span>
            </Label>
            <Input {...register("email", { required: "Email is required" })} value={formData.email} onChange={updateFormData} type="email" placeholder="zono@example.com" />
            {errors.email && <span className="text-danger">{errors.email.message}</span>}
          </Col>
          <Col xs="12">
            <Label>{Address} </Label>
            <Input {...register("address", { required: "Address is required" })} value={formData.address} onChange={updateFormData} type="textarea" rows={3} />
            {errors.address && <span className="text-danger">{errors.address.message}</span>}
          </Col>
          <Col sm="4">
            <Label>{Country}</Label>
            <Input {...register("country", { required: "Country is required" })} type="select" value={formData.country} onChange={updateFormData}>
              {CountryData.map((item, index) => (
                <option key={index}>{item}</option>
              ))}
            </Input>
            {errors.country && <span className="text-danger">{errors.country.message}</span>}
          </Col>
          <Col sm="4">
            <Label>{State}</Label>
            <Input {...register("state", { required: "State is required" })} value={formData.state} onChange={updateFormData} type="text" placeholder="Enter state" />
            {errors.state && <span className="text-danger">{errors.state.message}</span>}
          </Col>
          <Col sm="4">
            <Label>{ZipCode}</Label>
            <Input {...register("zip", { required: "Zip is required" })} value={formData.zip} onChange={updateFormData} type="text" />
            {errors.zip && <span className="text-danger">{errors.zip.message}</span>}
          </Col>
          <Col xs="12">
            <FormGroup check>
              <Input {...register("agreeTerms", { required: true })} onChange={updateFormData} id="invalid-check-wizard" type="checkbox" required />
              <Label className="mb-0 d-block" htmlFor="invalid-check-wizard" check>
                {RememberMeNext}
              </Label>
              {errors.agreeTerms && <span className="text-danger">{errors.agreeTerms.message}</span>}
            </FormGroup>
          </Col>
          <Col xs="12">
            <Label htmlFor="exampleFormControlTextarea-01">{OtherNotes}</Label>
            <Input {...register("otherNotes", { required: "Other notes is required" })} value={formData.otherNotes} onChange={updateFormData} type="textarea" rows={3} placeholder="Enter your queries..." />
            {errors.otherNotes && <span className="text-danger">{errors.otherNotes.message}</span>}
          </Col>
          <Col xs="12" className="text-end">
            <Button onClick={handleNextButton} color="primary">
              {ProceedToNext}
              <i className="fa fa-truck proceed-next pe-2" />
            </Button>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};
export default BillingForm;
